<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="agenda-table-title" :field="fields?.title" tag="h2" />
      <JssRichText class="agenda-table-location" :field="fields?.location" />
      <JssRichText class="agenda-table-date" :field="fields?.date" />
      <JssRichText class="agenda-table-time" :field="fields?.time" />
      <div class="agenda-table-content">
        <div class="agenda-table-header">
          <JssRichText class="agenda-table-header-time" :field="fields?.tableTime" />
          <JssRichText class="agenda-table-header-topic" :field="fields?.tableTopic" />
        </div>
        <div class="agenda-table-body">
          <div
            class="agenda-table-body-item"
            v-for="item in fields?.list || []"
            :key="item?.fields?.time?.value"
          >
            <div class="agenda-table-body-item-left">
              <JssRichText class="agenda-table-body-item-time" :field="item.fields?.time" />
            </div>
            <div class="agenda-table-body-item-right">
              <JssRichText class="agenda-table-body-item-right-title" :field="item.fields?.title" />
              <div class="agenda-table-body-item-right-job">
                <Icon name="people" v-if="item.fields?.jobtitle?.value" />
                <JssRichText :field="item.fields?.jobtitle" />
              </div>
              <JssRichText class="agenda-table-body-item-right-desc" :field="item.fields?.desc" />
              <div class="agenda-table-body-item-right-tags" v-if="item.fields?.list?.length > 0">
                <div
                  v-for="tag in item.fields?.list || []"
                  :key="tag"
                  class="agenda-table-body-item-right-tag"
                >
                  <Icon name="right-tag" />
                  <JssRichText
                    :field="tag.fields.text"
                    class="agenda-table-body-item-right-tag-text"
                  />
                </div>
              </div>
              <div
                class="agenda-table-body-item-right-media-wrapper"
                v-if="item.fields?.media || item.fields?.link?.value?.href"
              >
                <AdaptiveMedia
                  class="agenda-table-body-item-right-media"
                  :showImageRedius="false"
                  :field="item.fields?.media"
                  :options="{ autoplay: false }"
                  v-if="item.fields?.media"
                />
                <div
                  class="agenda-table-body-item-right-media-mask"
                  v-if="item.fields?.media && !isSubmitted"
                ></div>
                <siteButton
                  v-bind="item.fields?.button"
                  class="agenda-table-body-item-right-button"
                  :class="{ 'is-overlay': item.fields?.media }"
                  @click="(event) => onButtonClick(event, item.fields?.link?.value?.href)"
                  v-if="(item.fields?.media && !isSubmitted) || item.fields?.link?.value?.href"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <JssRichText class="agenda-table-note" :field="fields?.note" />
    </ContentGrid>
  </div>
</template>

<script>
import { computed, inject, onMounted, ref } from 'vue';
import utils from '@/utils';
import BUS_EVENTS from '@/utils/bus-events';

export default {
  name: 'AgendaTable',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    page: {
      type: Object,
    },
  },
  setup(props) {
    const bus = inject('$bus');
    let isSubmitted = ref(false);

    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'agenda-table'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    const onButtonClick = (event, href) => {
      event.preventDefault();
      if (href && isSubmitted.value) {
        window.open(href, '_blank');
        return;
      }
      bus?.emit(BUS_EVENTS.FORM_OPEN, {
        onSuccess: () => {
          // 提交成功后在当前页面 URL 拼接 src=success#showPlay
          const url = new URL(window.location.href);
          url.searchParams.set('src', 'success');
          url.hash = 'showPlay';
          window.history.replaceState({}, '', url.toString());
          isSubmitted.value = true;
        },
      });
    };

    onMounted(() => {
      // 读取 URL 参数 src=success，存在则视频正常展示
      const params = new URLSearchParams(window.location.search);
      isSubmitted.value = params.get('src') === 'success';
    });

    return {
      rootClass,
      rootStyle,
      onButtonClick,
      isSubmitted,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.agenda-table {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    color: $blue-night;
  }

  &-location {
    font-size: 16px;
    line-height: 1.2;
    color: $grey-black;
    margin-top: 12px;
  }

  &-date {
    font-size: 16px;
    line-height: 1.2;
    color: $grey-black;
    margin-top: 12px;
  }

  &-time {
    font-size: 16px;
    line-height: 1.2;
    color: $grey-black;
    margin-top: 12px;
    margin-bottom: 24px;
  }

  &-note {
    font-size: 16px;
    line-height: 1.2;
    color: $grey-black;
    margin-top: 12px;
  }

  &-content {
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $blue-night;
    font-size: 18px;
    line-height: 60px;
    color: $white;
    text-align: center;
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
    width: 1135px;

    &-time {
      flex: 1;
    }

    &-topic {
      flex: 4;
    }
  }

  &-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: $white;
    width: 1135px;

    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      border: 1px solid #e5e7eb;

      &:last-child {
        border-top: none;
      }

      &-left {
        flex: 1;
        text-align: center;
        font-size: 18px;
        color: #364153;
      }

      &-right {
        flex: 4;
        padding: 24px;
        border-left: 1px solid #e5e7eb;
        background: $white;

        &-title {
          font-size: 24px;
          line-height: 30px;
          font-weight: 700;
          color: #1d293d;
        }

        &-job {
          font-size: 16px;
          line-height: 24px;
          color: #45556c;
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 8px;
          svg {
            fill: transparent;
          }
        }

        &-desc {
          font-size: 16px;
          line-height: 24px;
          color: #45556c;
          margin-top: 12px;
        }

        &-tags {
          margin-top: 16px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 14px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        &-tag {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          font-size: 16px;

          svg {
            position: relative;
            top: 3px;
          }

          &-text {
            width: calc(100% - 24px);
          }
        }

        &-button {
          margin-top: 16px;
        }

        &-media {
          margin-top: 16px;

          &-wrapper {
            position: relative;
            margin-top: 16px;
            width: fit-content;
            max-width: 100%;
          }

          &-mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            backdrop-filter: blur(4px);
            -webkit-backdrop-filter: blur(4px);
            background: rgba(0, 0, 0, 0.2);
            z-index: 1;
          }
        }

        &-button.is-overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin-top: 0;
          z-index: 2;
        }
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-header {
      width: 100%;
    }

    &-body {
      width: 100%;
    }
  }

  @include mobile {
    &-header {
      display: none;
    }

    &-body {
      width: 100%;

      &-item {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        padding: 16px;
      }

      &-item-left {
        text-align: left;
        margin-bottom: 8px;
      }

      &-item-right {
        border-left: none;
        padding: 0;
      }
    }
  }
}
</style>
